import { render, staticRenderFns } from "./MaterialMoreSelect.vue?vue&type=template&id=684b11e9&"
import script from "./MaterialMoreSelect.vue?vue&type=script&lang=js&"
export * from "./MaterialMoreSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports